import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./translations/translationEN.json";
import translationFR from "./translations/translationFR.json";
import translationGR from "./translations/translationGR.json";
import translationSR from "./translations/translationSR.json";
import translationCH from "./translations/translationCH.json";

const resources = {
  English: {
    translation: translationEN,
  },
  French: {
    translation: translationFR,
  },
  German: {
    translation: translationGR,
  },
  Serbian: {
    translation: translationSR,
  },
  Swiss: {
    translation: translationCH,
  },
};

const defaultLanguage = "French";

i18n
  .use(initReactI18next)
  .init({
    debug: true,
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: false,
    },
    resources,
  });

export default i18n;
